import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface roleInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: roleInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const roleSlice = createSlice({
  name: 'roleSlice',
  initialState,
  reducers: {
    setRoleTotalPages: (
      state: roleInitialSliceI,
      actions: PayloadAction<roleInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
